import { useRef } from "react"
import { Box } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"

import { CustomTab, LeftIcon, RightIcon, theme } from "./Atom"
import { useSelector } from "react-redux"

type ProvidersMetricTabsProps = {
  fetchProviderData: any
}

export default function ProvidersMetricTabs(props: ProvidersMetricTabsProps) {
  const { fetchProviderData } = props

  const tabsRef = useRef<any>(null)

  const loading = useSelector((state: any) => {
    return state.app.loading
  })

  const selectedProvidersMetricTab = useSelector((state: any) => {
    return state.providers.selectedProvidersMetricTab
  })

  const providersMetricTabs = useSelector((state: any) => {
    return state.providers.providersMetricTabs
  })

  const handleChange = async (tab: any) => {
    await fetchProviderData(tab)
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: 320, sm: 480, xl: "100%", md: "100%" },
          bgcolor: "#3C77EF",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
        }}
      >
        {providersMetricTabs?.length ? (
          <Tabs
            ref={tabsRef}
            scrollButtons="auto"
            ScrollButtonComponent={(props) => {
              if (props.direction === "left") {
                return (
                  <IconButton
                    size="small"
                    style={{ right: 36 }}
                    {...props}
                    disableRipple={true}
                  >
                    <LeftIcon disabled={props.disabled} />
                  </IconButton>
                )
              } else if (props.direction === "right") {
                return (
                  <IconButton
                    size="small"
                    style={{ right: 0 }}
                    {...props}
                    disableRipple={true}
                  >
                    <RightIcon disabled={props.disabled} />
                  </IconButton>
                )
              } else {
                return null
              }
            }}
            value={selectedProvidersMetricTab?.index || 0}
            // onChange={handleChange}
            variant="scrollable"
            aria-label="visible arrows tabs example"
            sx={{
              width: "100%",
              color: "primary.main",
              position: "relative",
              height: "8vh",
              paddingRight: 13,
              [`& .${tabsClasses.scrollButtons}`]: {
                position: "absolute",
                "&.Mui-disabled": { opacity: 0.9 },
              },
            }}
            TabIndicatorProps={{
              style: { display: "none" },
            }}
          >
            {providersMetricTabs?.map((tab: any, index: any) => (
              <CustomTab
                key={tab?.metric_id}
                label={tab?.metric_name}
                onClick={() => handleChange(tab)}
                disabled={loading}
                style={{
                  // fontSize: selectedProvidersMetricTab?.metric_id === tab?.metric_id ? "16px" : "16px",
                  backgroundColor:
                    selectedProvidersMetricTab?.metric_id === tab?.metric_id
                      ? "#ffffff"
                      : "#1c56ce",
                  color:
                    selectedProvidersMetricTab?.metric_id === tab?.metric_id
                      ? "black"
                      : "white",
                  marginLeft: index === 0 ? "8px" : "0",
                  fontSize: "16px",
                  fontWeight:
                    selectedProvidersMetricTab?.metric_id === tab?.metric_id
                      ? "600"
                      : "400",
                  width: "fit-content",
                  textTransform: "capitalize",
                }}
              />
            ))}
          </Tabs>
        ) : (
          <Box
            sx={{
              backgroundColor: "#3C77EF",
              height: "100%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "30px",
            }}
          >
            Select a Metric
          </Box>
        )}
      </Box>
    </ThemeProvider>
  )
}
